import React from 'react';
import {
  Form, Row, Col,  Button, InputNumber
} from 'antd';
import img from './../../assets/img/Illustration.png';
class FD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values,id:this.props.id });
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title' style={{fontSize:'20px',marginLeft:'18px'}}>Update Rate</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Rate</legend>
                  {getFieldDecorator('rate', {
                    rules: [{ required: true, message: 'Please enter Rate.' }
                    ],
                  })(<InputNumber  min={0}
                    step={0.1}
                    precision={1}
                   autoComplete={"nope"}  className="mi_input" type="number" placeholder='Rate'/>)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
         <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7} ></Col>
            <Col span={5} >
              <Button className="mi_button_right" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
                        </Button>
            </Col>
            <Col span={5} >
              <Button htmlType="submit" type="primary">
                Submit
                    </Button>
            </Col>
            <Col span={7} >
              <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const UpdateEnquiryRate = Form.create()(FD);
export default UpdateEnquiryRate;